import { render, staticRenderFns } from "./certifications.vue?vue&type=template&id=7f2bde86&"
import script from "./certifications.vue?vue&type=script&lang=js&"
export * from "./certifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports